import { createContext, useContext } from "react"

// Stable string ID that scopes all dashboard RTK slice lookups. Not state — "default" for now.
const DashboardIdContext = createContext<string>("default")

export const DashboardIdProvider = DashboardIdContext.Provider

export function useDashboardId(): string {
  return useContext(DashboardIdContext)
}
